import { render, staticRenderFns } from "./EditorPropertiesEquip.vue?vue&type=template&id=bf9e0e24&scoped=true&"
import script from "./EditorPropertiesEquip.vue?vue&type=script&lang=js&"
export * from "./EditorPropertiesEquip.vue?vue&type=script&lang=js&"
import style0 from "./EditorPropertiesEquip.vue?vue&type=style&index=0&id=bf9e0e24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9e0e24",
  null
  
)

export default component.exports